import Vue from 'vue';
import getDefaultState from './state';

export function flush(state) {
  state.coupon = null;
  state.current = null;
  state.customerName = null;
  state.deliveryMethod = null;
  state.isCatering = false;
  state.location = null;
  state.orderDate = null;
  state.paymentData = null;
  state.paymentMethod = null;
  state.products = [];
  state.useCredit = false;
  state.totalDiscount = 0;
  state.totalPrice = 0;
}

export function setNormalOrder(state) {
  state.isCatering = false;
}

export function setCateringOrder(state) {
  state.isCatering = true;
}

export function updateCurrentOrder(state, { order }) {
  state.current = order;
}

export function addProduct(state, { product }) {
  state.products.push(product);
}

export function updateProduct(state, { product }) {
  Vue.set(
    state.products,
    state.products.findIndex((p) => p.uid === product.uid),
    product,
  );
}

export function removeProduct(state, { product }) {
  const index = state.products.findIndex((p) => p.uid === product.uid);
  if (index >= 0) {
    state.products.splice(index, 1);
  }
}

export function updateTotalPrice(state, { totalPrice }) {
  state.totalPrice = totalPrice;
}

export function updateTotalDiscount(state, { totalDiscount }) {
  state.totalDiscount = totalDiscount;
}

export function setValidCouponCode(state, payload) {
  state.coupon = payload;
}

export function updateLocation(state, payload) {
  state.location = payload;
}

export function updateDeliveryMethod(state, payload) {
  state.deliveryMethod = payload;
}

export function updatePaymentMethod(state, payload) {
  state.paymentMethod = payload;
}

export function updateOrderDate(state, { date }) {
  state.orderDate = date;
}

export function updateCustomerName(state, payload) {
  state.customerName = payload;
}

export function updatePreviousOrder(state, { previousOrder }) {
  state.previousOrder = previousOrder;
}

export function updatePaymentData(state, {
  cardNumber, expirationMonth, expirationYear, ccv, phoneNumber, paymentMethodId,
}) {
  if (phoneNumber) {
    state.paymentData = {
      phoneNumber,
    };
  }
  else if (cardNumber && expirationMonth && expirationYear && ccv) {
    const expiration = expirationYear.toString().substr(2, 2) + expirationMonth;
    // eslint-disable-next-line no-param-reassign
    cardNumber = cardNumber.toString().replace(/\D/g, '');

    state.paymentData = {
      cardNumber,
      ccv,
      expiration,
      paymentMethodId,
    };
  }
  else {
    state.paymentData = null;
  }
}
